<template>
  <div id="box" class="box">
    <div class="content">
      <div class="login-wrapper">
        <h1>管理后台</h1>
        <div class="login-form">
          <div class="username form-item">
            <span>账号</span>
            <input
              type="text"
              class="input-item"
              placeholder="请输入账号"
              v-model.trim="account"
              @keydown.enter="login"
            />
          </div>
          <div class="password form-item">
            <span>密码</span>
            <input
              type="password"
              class="input-item"
              placeholder="请输入密码"
              v-model="pwd"
              @keydown.enter="login"
            />
          </div>
          <button class="login-btn" @click="login">登 录</button>
        </div>
        <div class="divider">
          <span class="line"></span>
          <span class="divider-text">其他方式登录</span>
          <span class="line"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userlogin } from "@/api";
import user from "@/api/mockServeData/user";
import Cookie from "js-cookie";

export default {
  name: "Login",
  data() {
    return {
      // account: "admin",
      // pwd: "123456",
      account: "",
      pwd: "",
    };
  },
  methods: {
    loginQQ() {
      this.$message("还在开发中,别乱点！");
    },
    loginWeChat() {
      this.$message("还在开发中,别乱点！");
    },
    login() {
      const t = this;
      if (t.account == "" || t.account == null) {
        t.$message.error("账号都没填写怎么登录！");
        return;
      }
      if (t.pwd == "" || t.pwd == null) {
        t.$message.error("密码也没有填写呢！");
        return;
      }
      // let formData = new FormData();
      // formData.append("name", t.account);
      // formData.append("password", t.pwd);

      // this.$store.commit("setUserInfo", {
      //   userName: t.account,
      // });
      // this.$message.success("登录成功");

      // Cookie.set("userName", t.account);
      // Cookie.set("token", "true");
      // this.$router.push("/home");
      
      userlogin({
        name:t.account,
        password:t.pwd
      }).then((res) => {
        console.log(res);
        
        if (res.code == 200) {
          this.$store.commit("setUserInfo", {
            userName: t.account,
          });
          this.$message.success("登录成功");

          Cookie.set("userName", t.account);
          Cookie.set("token", res.data.token);
          Cookie.set("is_root", res.data.is_root);
          this.$router.push("/home");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@charset "UTF-8";
* {
  margin: 0;
  padding: 0;
}

/*公共CSS*/
.box {
  width: 100vw;
  height: 100vh;
  background-color: #4A90E2;
  display: flex;
}
.box .content .login-wrapper h1 {
  text-align: center;
}
.box .content .login-wrapper .login-form .form-item {
  margin: 20px 0;
}
.box .content .login-wrapper .login-form .form-item span {
  display: block;
  margin: 5px 20px;
  font-weight: 100;
}
.box .content .login-wrapper .login-form .form-item .input-item {
  width: 100%;
  border-radius: 40px;
  padding: 20px;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: 200;
}
.box .content .login-wrapper .login-form .form-item .input-item:focus {
  outline: none;
}
.box .content .login-wrapper .login-form .login-btn {
  width: 100%;
  border-radius: 40px;
  color: #fff;
  border: 0;
  font-weight: 100;
  margin-top: 10px;
  cursor: pointer;
}
.box .content .login-wrapper .divider {
  width: 100%;
  margin: 20px 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box .content .login-wrapper .divider span:nth-child(1) {
  flex: 1;
}
.box .content .login-wrapper .divider span:nth-child(3) {
  flex: 1;
}
.box .content .login-wrapper .divider .line {
  display: inline-block;
  max-width: 30%;
  width: 30%;
}
.box .content .login-wrapper .divider .divider-text {
  vertical-align: middle;
  margin: 0px 20px;
  line-height: 0px;
  display: inline-block;
  width: 100px;
}
.box .content .login-wrapper .other-login-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box .content .login-wrapper .other-login-item {
  border: 1px solid rgb(214, 222, 228);
  padding: 10px;
  margin: 10px;
  cursor: pointer;
}

/*一般大于手机的尺寸CSS*/
@media (min-width: 767px) {
  .box {
    // background-color: rgb(29, 67, 89);
  }
  .box .content {
    width: 85vw;
    height: 90vh;
    background: url("../assets/images/login_bg.png") no-repeat;
    background-size: 50% 100%;
    background-repeat: no-repeat;
    position: absolute;
    right: 15%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    background-color: #fff;
  }
  .box .content .login-wrapper {
    width: 25vw;
    position: absolute;
    right: 25%;
    top: 50%;
    transform: translate(50%, -50%);
  }
  .box .content .login-wrapper h1 {
    text-align: center;
    font-size: 45px;
    color: rgb(81, 100, 115);
    margin-bottom: 40px;
  }
  .box .content .login-wrapper .login-form {
    margin: 10px 0;
  }
  .box .content .login-wrapper .login-form .form-item span {
    color: rgb(81, 100, 115);
  }
  .box .content .login-wrapper .login-form .form-item .input-item {
    height: 60px;
    border: 1px solid rgb(214, 222, 228);
  }
  .box .content .login-wrapper .login-form .login-btn {
    height: 50px;
    background-color: rgb(59, 72, 89);
    font-size: 20px;
  }
  .box .content .login-wrapper .divider .line {
    border-bottom: 1px solid rgb(214, 222, 228);
  }
  .box .content .login-wrapper .other-login-item {
    border-radius: 20px;
  }
  .box .content .login-wrapper .other-login-item img {
    width: 40px;
    height: 40px;
  }
}
/*手机端CSS*/
@media (max-width: 768px) {
  .box .content {
    width: 100vw;
    height: 100vh;
    background: url("../assets/images/login_bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  .box .content .login-wrapper {
    width: 70%;
    padding: 10px;
    border-radius: 8px;
    background-color: rgba(0,0,0,0.5);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .box .content .login-wrapper h1 {
    font-size: 30px;
    color: #FFF;
  }
  .box .content .login-wrapper .login-form .form-item {
    margin: 10px 0;
  }
  .box .content .login-wrapper .login-form .form-item span {
    color: #FFF;
  }
  .box .content .login-wrapper .login-form .form-item .input-item {
    height: 30px;
    border: 1px solid #fff;
    background-color: transparent;
    color: #FFF;
  }
  .box .content .login-wrapper .login-form .login-btn {
    height: 40px;
    background-color: rgb(235, 95, 93);
    font-size: 16px;
  }
  .box .content .login-wrapper .divider .line {
    border-bottom: 1px solid #fff;
  }
  .box .content .login-wrapper .divider .divider-text {
    color: #fff;
  }
  .box .content .login-wrapper .other-login-item {
    border-radius: 15px;
  }
  .box .content .login-wrapper .other-login-item img {
    width: 35px;
    height: 35px;
  }
} /*# sourceMappingURL=style.css.map */
</style>
